
import { setupIonicReact } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import { _homeNodePath , _lang, _nextSubscriptionDueDate, _nodes, _synched,
  _syncTimer, _userEmail, _userUniqueId, _l2audio, _l2image, _rootName, _debugMode,
  _l2color, _showCardSizing, _topSentences, _cachedLocalAutoL2image, 
  _previousPath, _clipboardCards, _dict } from './components/constants';
import { Route, Switch } from 'react-router-dom';
import { IonReactRouter } from '@ionic/react-router';
import PrivacyPage from './pages/Privacy';
import LandingPage from './pages/LandingPage';
import AppRoot from './pages/AppRoot';
import Logout from './components/Logout';
import InitRouting from './pages/InitRouting';



setupIonicReact();
const App: React.FC = () => {
  return <IonReactRouter>
  <Switch>
      <Route path="/logout" exact={true}><Logout /></Route>
      <Route path="/privacy" exact={true}><PrivacyPage /></Route>
      <Route><InitRouting /></Route>
  </Switch>
</IonReactRouter>;
}

export default App;

